import Facebook from "../../assets/icons/facebook.svg";
import Twitter from "../../assets/icons/twitter.svg";
import Instagram from "../../assets/icons/instagram.svg";
import Mail from "../../assets/icons/Mail.svg";
import routes from "routes";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { getSettingsData } from "services/_settings";
import logo from "../../assets/images/Logo5.svg";
import "react-quill/dist/quill.snow.css";

const UserFooter = () => {
  const [settingData, setSettingData] = useState({});
  const userRoutes = routes.filter((route) => route.layout === "/user");

  const getInitialValue = async () => {
    const response = await getSettingsData();
    if (response.isSuccess) {
      const settingsObject = response.data.reduce((acc, setting) => {
        acc[setting.key] = setting.value;
        return acc;
      }, {});

      setSettingData(settingsObject);
    }
  };

  useEffect(() => {
    getInitialValue();
  }, []);

  return (
    <>
      <div>
        <footer>
          <div className="container">
            <div className="grid gap-[50px] grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr]">
              <div>
                <img src={logo} alt="" className="w-[180px] mb-[15px] " />
                <p
                  style={{ whiteSpace: "pre-line" }}
                  className=" text-[14px] text-[#fff]"
                  dangerouslySetInnerHTML={{
                    __html: settingData.disclaimer
                      ? `${settingData.disclaimer}`
                      : "",
                  }}
                />
                <ul className="flex gap-[10px] md:mt-[30px] mt-[15px] items-center">
                  {settingData.facebook_link ? (
                    <li>
                      <Link
                        to={settingData.facebook_link}
                        className="w-[31px] h-[31px] rounded-[100px] bg-white flex justify-center items-center"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={Facebook} alt="facebook" />
                      </Link>
                    </li>
                  ) : (
                    <li>
                      <div className="w-[31px] h-[31px] rounded-[100px] bg-white flex justify-center items-center ">
                        <img src={Facebook} alt="facebook" />
                      </div>
                    </li>
                  )}

                  {settingData.twitter_link ? (
                    <li>
                      <Link
                        to={settingData.twitter_link}
                        className="w-[31px] h-[31px] rounded-[100px] bg-white flex justify-center items-center"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={Twitter} alt="twitter" />
                      </Link>
                    </li>
                  ) : (
                    <li>
                      <div className="w-[31px] h-[31px] rounded-[100px] bg-white flex justify-center items-center ">
                        <img
                          src={Twitter}
                          alt="twitter"
                          className="brightness-50"
                        />
                      </div>
                    </li>
                  )}

                  {settingData.instagram_link ? (
                    <li>
                      <Link
                        to={settingData.instagram_link}
                        className="w-[31px] h-[31px] rounded-[100px] bg-white flex justify-center items-center"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={Instagram}
                          alt="instagram"
                          className="brightness-50"
                        />
                      </Link>
                    </li>
                  ) : (
                    <li>
                      <div className="w-[31px] h-[31px] rounded-[100px] bg-white flex justify-center items-center ">
                        <img
                          src={Instagram}
                          alt="instagram"
                          className="brightness-50"
                        />
                      </div>
                    </li>
                  )}
                </ul>
              </div>

              <div>
                <h2 className="text-[28px] font-[600] text-[#fff]">Links</h2>
                <ul className="mt-[10px]">
                  {userRoutes.map((route) => (
                    <li key={route.path} className="md:mb-[10px] mb-[8px]">
                      <Link to={route.path} className="text-[14px] text-[#fff]">
                        {route.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h2 className="text-[28px] font-[600] text-[#fff]">
                  Contact Us
                </h2>
                <ul className="md:mt-[20px] mt-[10px]">
                  <li className="mb-[10px] flex gap-[10px] text-[#fff]">
                    <img src={Mail} alt="Mail" />
                    {settingData.company_email}
                  </li>
                </ul>
              </div>
            </div>
            <div className="border-t border-[#fff] mt-[15px]">
              <p className="pt-[15px] text-[#fff] text-center  text-[14px]">
                Copyright © 2025 Abhijeet Danve/Rheum Solutions LLC. All rights
                reserved. The A-Tool&copy; is registered with the U.S. Copyright
                Office
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default UserFooter;
